import { AutogenLayoutPortalFieldsDefs } from "./autogen/AutogenLayoutPortalFieldsDefs";
import {  FocusEvent } from "@mcleod/components";

export class PortalFieldsDefs extends AutogenLayoutPortalFieldsDefs {
    private timer: any;

    override onLoad() {
        clearInterval(this.timer);
        this.timer = setInterval(() => this.setid(), 200);
    }

  async setid() {
    clearInterval(this.timer);
    this.timer = null;
    if( this.textboxLgxfId.text == "" && this.sourceRenlgxflds.mode == "add" )
    {
        await this.sourceRenlgxflds2.search();
        const rows: any[] = this.sourceRenlgxflds2.data;
        let maxid = 0;
        for (const row of rows) {
            const fid = row._data.lgxf_id;
            if( fid > maxid )
                maxid = fid;
        }
        maxid++;
        this.textboxLgxfId.text = maxid.toString();
    }
  }

}
